<script lang="ts" setup>
import { googleTokenLogin } from 'vue3-google-login';

import GoogleAuthIcon from '@/assets/images/anti-spy/auth/google-auth-icon.svg';
import { SignUpWithGoogle } from '@/api/auth';
import { ksEvent } from '@/plugins/awsKinesis';

const props = withDefaults(
  defineProps<{
    kindOfPage?: string;
  }>(),
  {
    kindOfPage: 'login',
  },
);

const emit = defineEmits<{
  (event: 'change-email', value: string): void;
}>();

const changeCsrfToken = function changeCsrfToken(newToken: string) {
  const tokenMeta = document.querySelector<HTMLMetaElement>(
    '[name="csrf-token"]',
  );

  tokenMeta?.setAttribute('content', newToken);
};

const handleGoogleAuthClick = function handleGoogleAuthClick() {
  if (window.gtag) {
    window.gtag('event', `${props.kindOfPage}_page_google_auth_selected`);
  }

  ksEvent(`${props.kindOfPage}_page_google_auth_selected`);

  googleTokenLogin({
    clientId: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
  })
    .then((response) => SignUpWithGoogle({ token: response.access_token }))
    .then((data) => {
      emit('change-email', data.email);
      changeCsrfToken(data.csrf_token);
    })
    .catch((error) => {
      if ('type' in error && error.type !== 'popup_closed') {
        throw error;
      }
    });
};
</script>

<template>
  <button
    id="google-auth-button"
    dir="ltr"
    type="button"
    class="google-auth-button"
    @click="handleGoogleAuthClick"
  >
    <img
      :src="GoogleAuthIcon"
      alt="google auth icon"
      width="25"
      height="24"
    />
    <span>Google</span>
  </button>
</template>

<style lang="scss" scoped>
.google-auth-button {
  $this: 'google-auth-button';

  display: flex;
  column-gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 16px;
  outline: none;
  border: 1px solid $color-dark-blue-300;
  background: $color-white;
  border-radius: 12px;
  min-height: 48px;
  cursor: pointer;
  color: $color-new-black-900;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  transition: $anim-primary;

  span {
    margin: 0 auto;
  }

  &:hover {
    background-color: $color-dark-blue-100;
  }
}
</style>
